<template>
  <div class="content">
    <div class="response_table">
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
        <tr>
          <th scope="col">
            {{ translate('tariffication.tariff_packet.name_for_client') }}
          </th>
          <th scope="col">
            {{ translate('tariffication.tariff_packet.name') }}
          </th>
          <th scope="col">
            {{ translate('tariffication.tariff_packet.traffic_limit') }}
          </th>
          <th scope="col">
            {{ translate('tariffication.tariff_packet.is_required') }}
          </th>
          <th scope="col">
            {{ translate('tariffication.tariff_packet.status') }}
          </th>
          <th scope="col">
            {{ translate('tariffication.tariff_packet.cost_for_client') }}
          </th>
          <th scope="col">
            {{ translate('tariffication.tariff_packet.available_purchase') }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(packet, key) in packet_list" :key="key"
            :class="{ packet_active: packet.status === 1, packet_not_active: packet.status === 0 }">
          <td :data-label="translate('tariffication.tariff_packet.name_for_client')">
            {{ packet.name }}
          </td>
          <td :data-label="translate('tariffication.tariff_packet.name')">
            {{ packet.hidden_name }}
          </td>
          <td :data-label="translate('tariffication.tariff_packet.traffic_limit')">
            {{ packet.traffic_limit }}
          </td>
          <td :data-label="translate('tariffication.tariff_packet.is_required')">
            {{ packet.is_required > 0 ? 'Yes' : 'No' }}
          </td>
          <td :data-label="translate('tariffication.tariff_packet.status')">
            {{ packet.status > 0 ? 'Yes' : 'No' }}
          </td>
          <td :data-label="translate('tariffication.tariff_packet.cost_for_client')">
            {{ packet.cost }}
          </td>
          <td :data-label="translate('tariffication.tariff_packet.available_purchase')">
            {{ packet.available_purchase > 0 ? 'Yes' : 'No' }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>


export default {
  name: "TariffPackets",
  props: ['packets'],
  data() {
    return {}
  },
  computed: {
    packet_list() {
      return this.packets.sort((a, b) => a.status < b.status ? 1 : -1)
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.response_table {
  padding: 0;

  table {

    .packet_active {
      background-color: #54dfa030;
    }

    .packet_not_active {
      background-color: #eeeeee;
    }

    .status {
      width: 40px;
      vertical-align: middle;
    }

    .active {
      width: 70px;

      .fz16 {
        font-size: 16px;
      }
    }

    tbody {
      .link {
        color: black;
      }
    }
  }

  table tr {
    background-color: white;


    &:hover {
      background-color: #f1f1f1;
    }
  }
}
</style>
